import { Dispatch, SetStateAction } from "react";
import { IOnboardingChoices } from "~/types/account";
import { SelectCategory } from "./SelectCategory";
import { PreferredRegion } from "./PreferredRegion";

interface Step {
  titleKey: string;
  component: (props: {
    onboardingChoices: IOnboardingChoices;
    setOnboardingChoices: Dispatch<SetStateAction<IOnboardingChoices>>;
  }) => JSX.Element;
}

export const steps: Step[] = [
  {
    titleKey: "onboarding.category_title",
    component: SelectCategory,
  },
  {
    titleKey: "onboarding.region",
    component: PreferredRegion,
  },
];
